import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

function QuizReportRules() {
    const [rules, setRules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [deleteId, setDeleteId] = useState(null);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        fetchRules();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchRules = async () => {
        try {
            setLoading(true);
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/admin/quiz/report-rules/list`
            );
            const data = await res.json();

            if (data.status === 'success') {
                setRules(data.data.rules || []);
            } else {
                toast.error(data.message || 'Failed to fetch report rules');
            }
        } catch (error) {
            console.error('Error fetching report rules:', error);
            toast.error('Error fetching report rules');
        } finally {
            setLoading(false);
        }
    };

    const handleToggleActive = async (rule) => {
        try {
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/admin/quiz/report-rules/${rule._id}`,
                {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ isActive: !rule.isActive })
                }
            );

            const data = await res.json();
            if (data.status === 'success') {
                toast.success(`Report rule ${!rule.isActive ? 'activated' : 'deactivated'}`);
                fetchRules();
            } else {
                toast.error(data.message || 'Update failed');
            }
        } catch (error) {
            console.error('Error toggling report rule:', error);
            toast.error('Error toggling report rule');
        }
    };

    const handleDelete = async () => {
        try {
            setDeleting(true);
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/admin/quiz/report-rules/${deleteId}`,
                { method: 'DELETE' }
            );

            const data = await res.json();
            if (data.status === 'success') {
                toast.success('Report rule deleted successfully');
                setDeleteId(null);
                window.$?.('#modaldelete_reportrule').modal('hide');
                fetchRules();
            } else {
                toast.error(data.message || 'Delete failed');
            }
        } catch (error) {
            console.error('Error deleting report rule:', error);
            toast.error('Error deleting report rule');
        } finally {
            setDeleting(false);
        }
    };

    return (
        <>
            <ToastContainer autoClose={3000} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft">Quiz Report Rules</h1>
                        </div>
                        <div className="col-sm-6 txt_rgt">
                            <Link to="/quizReportRulesAdd" className="btn btn-blue">
                                Add Report Rule
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                {loading ? (
                                    <div className="text-center p-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : rules.length > 0 ? (
                                    <table width="100%" className="table table-striped table-bordered txt_lft">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '140px' }}>Segment</th>
                                                <th>Headline</th>
                                                <th style={{ width: '150px' }}>Nurture Track</th>
                                                <th style={{ width: '100px' }}>Active</th>
                                                <th style={{ width: '100px' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rules.map((rule) => (
                                                <tr key={rule._id}>
                                                    <td>
                                                        <code>{rule.segment}</code>
                                                    </td>
                                                    <td>{rule.headline}</td>
                                                    <td>{rule.nurtureTrack}</td>
                                                    <td align="center">
                                                        <div className="toggle-switch">
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={rule.isActive}
                                                                    onChange={() => handleToggleActive(rule)}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                            <span className="toggle-label">
                                                                {rule.isActive ? 'On' : 'Off'}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div align="center">
                                                            <Link to={`/quizReportRulesAdd/${rule._id}`} className="crsr_pntr">
                                                                <i className="fa-solid fa-pen mr-2" title="Edit" />
                                                            </Link>
                                                            <button
                                                                className="crsr_pntr btn btn-link p-0"
                                                                onClick={() => setDeleteId(rule._id)}
                                                                data-toggle="modal"
                                                                data-target="#modaldelete_reportrule"
                                                            >
                                                                <i className="fa-solid fa-trash-can" title="Delete" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="text-center p-5">
                                        <p>No report rules found</p>
                                        <Link to="/quizReportRulesAdd" className="btn btn-primary">
                                            Create your first report rule
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Modal */}
            <div className="modal fade" id="modaldelete_reportrule" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirm Delete</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this report rule?</p>
                            <p className="text-muted small">
                                A lead who picked this segment will get no report until a new rule is created for it.
                                Consider deactivating instead of deleting.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleDelete}
                                disabled={deleting}
                            >
                                {deleting ? 'Deleting...' : 'Delete'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuizReportRules
